export const TAG_GAME_IDS: Record<string, string> = {
    Hot: "7000",
    hot: '7000',
    Baccarat: "9",
    Bingo: "1015",
    blackjack: "7",
    BonusBuy: "13",
    Card: "1011",
    Casual: "1002",
    Craps: "1004",
    Crash: "1008",
    CrashatiGame: "1001",
    CrashCasino: "1000",
    EnhancedRTP: "14",
    Exclusives: "11",
    "FeatureBuy-in": "5",
    Fishing: "1010",
    GameShows: "12",
    HighVolatility: "4",
    LiveCasino: "3",
    Lottery: "1003",
    Mahjong: "1014",
    MiniGame: "1013",
    NewReleases: "10",
    'new-releases': "10",
    Originals: "1",
    Poker: "1006",
    ProvablyFairs: "1005",
    roulette: "8",
    Slots: "2",
    Softswiss: "9001",
    Sports: "1012",
    'table-game': "6",
    VideoPoker: "1007",
    VirtualSports: "1009",
    MiniGames: "1013",
};
